import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tuja',
  templateUrl: './tuja.component.html',
  styleUrls: ['./tuja.component.scss']
})
export class TujaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
